import { createReducer, on } from "@ngrx/store";
import { TestPrioritizationActions } from "../actions/test-prioritization.action";
import { initialState } from "../states/test-prioritization.state";

export const testPrioritizationReducer = createReducer(
  initialState,
  on(TestPrioritizationActions.loadTestCases, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(
    TestPrioritizationActions.loadTestCasesSuccess,
    (state, { testCasesToSourceMapping }) => ({
      ...state,
      testCasesToSourceMapping,
      loading: false,
    })
  ),
  on(TestPrioritizationActions.loadTestCasesFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),
  on(TestPrioritizationActions.createMapping, (state) => ({
    ...state,
    loading: true,
    error: null,
    isMappingCreated: false,
  })),
  on(TestPrioritizationActions.createMappingSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    isMappingCreated: true,
    mappingResponse: response,
  })),
  on(TestPrioritizationActions.createMappingFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
    isMappingCreated: false,
  })),
  on(
    TestPrioritizationActions.updateMappingResponse,
    (state, { mappingResponse }) => ({
      ...state,
      testCasesToSourceMapping: [],
      mappingResponse: mappingResponse,
    })
  ),
  on(TestPrioritizationActions.updateMapping, (state) => ({
    ...state,
    loading: true,
    error: null,
    isMappingCreated: false,
  })),

  on(TestPrioritizationActions.loadRecommendations, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(
    TestPrioritizationActions.loadRecommendationsSuccess,
    (state, { recommandations }) => ({
      ...state,
      recommandations,
      loading: false,
    })
  ),
  on(
    TestPrioritizationActions.loadRecommendationsFailure,
    (state, { error }) => ({
      ...state,
      error,
      loading: false,
    })
  ),
  on(TestPrioritizationActions.clearStore, () => initialState)
);
